
"use client"

import { analyticEvents, handlePostAnalytics } from "@/apiUtils/analyticsUtils";
import { analyticEventSources, analyticEventTypes } from "@/apiUtils/constants";
import {
    PromotionalBannerItem
} from "@/common/lib/types";
import useDebounceCallback from "@/hooks/useDebounceCallback";
import { useRef } from "react";
import { ICategoryData } from "../../clp/types";
import Promotions from "./Promotions";

const PromotionsView = ({
    promotionalData,
    locale,
}: {
    promotionalData: ICategoryData["promotionalData"];
    locale: string;
}) => {
    const gaDataRef = useRef<PromotionalBannerItem[]>([]);
    const debounce = useDebounceCallback(99);

    const handlePromotionClick = (data: PromotionalBannerItem) => {
        handlePostAnalytics({
            eventType: analyticEventTypes.ACTIONS,
            data: {
                target: analyticEvents.SELECT_PROMOTION,
                promotions: [data],
                source: analyticEventSources.PROMOTIONAL_BANNER,
            },
        });
    };

    const triggerAnalyticsPromotionImpression = (visiblePromotionData: PromotionalBannerItem[]) => {
        handlePostAnalytics({
            eventType: analyticEventTypes.DETAILS,
            data: {
                target: analyticEvents.VIEW_PROMOTION,
                promotions: visiblePromotionData,
                source: analyticEventSources.PROMOTIONAL_BANNER,
            },
        });
    };

    const gaTriggerHandler = () => {
        triggerAnalyticsPromotionImpression(gaDataRef.current);
        gaDataRef.current = [];
    };

    const handleVisible = (isVisible: boolean, data: PromotionalBannerItem) => {
        if (isVisible) {
            gaDataRef.current.push(data);
            debounce(gaTriggerHandler);
        }
    };

    return (
        <Promotions locale={locale} promotionalData={promotionalData} handleOnVisible={handleVisible} handleClick={handlePromotionClick} />
    );
};

export default PromotionsView;